import React, { Component } from "react";
import { NavLink, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";

export default class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      data_ready: false,
      notice_message: "",
      display_error: false,
      pwd_reset_req: false,
      id: "",
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  buildLoginParams = () => {
    const params = {
      auth: {
        email: this.state.email,
        password: this.state.password,
      },
    };

    return JSON.stringify(params);
  };

  displayError = (error) => {
    this.setState({
      notice_message: error,
      display_error: true,
    });
  };

  serverLogin = () => {
    return new Promise((resolve, reject) => {
      try {
        fetch(process.env.API_URL + "user_token", {
          method: "POST",
          body: this.buildLoginParams(),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }).then((resp) => {
          if (resp.status === 404) {
            this.displayError("Incorrect user name or password.");
          } else {
            resp
              .json()
              .then((data) => {
                console.log("Log user in data: ", data);
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  submitLogin = (e) => {
    e.preventDefault();
    this.serverLogin()
      .then((data) => {
        const token = data.jwt;
        // console.log('TOKEN IN SUBMIT LOGIN: ', token);
        const cookies = new Cookies();
        cookies.set("user_session", token, { path: "/" });
        // console.log('LOGIN PROPS: ', this.props);
        this.props.toggleLoggedInState();
        // History is undefined here and I can't figure out why
        console.log("SUBMIT", this.state);
        this.props.history.push("/");
        // window.location.href = process.env.BASE_URL+'syllabi/index';
        // this.props.setLoggedInState();
      })
      .catch((err) => {
        // console.log('SUBMIT LOGIN ERROR: ', err);
        if (this._isMounted) {
          this.displayError(
            "There was a problem logging in. Please contact an administrator."
          );
        }
      });
  };

  handleChange = (e, attribute) => {
    const clonedState = Object.assign({}, this.state);
    clonedState[attribute] = e.target.value;
    this.setState(clonedState);
  };

  renderError = () => {
    if (this.state.display_error) {
      return (
        <div className="row">
          <div className="col-12 text-center">
            <p className="alert alert-danger">{this.state.notice_message}</p>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  render() {
    return (
      <div className="container">
        {this.renderError()}
        <div className="row">
          <div className="col-12 text-center mt-5">
            <div className="alert alert-danger" role="alert">
              Passwords are case sensitive
            </div>
            <h1>Login</h1>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center mt-5">
          <div className="col-6 text-center">
            <div className="card">
              <form className="form p-3">
                <div className="form-group">
                  <label>Email</label>
                  <div className="">
                    <input
                      id="email"
                      type="text"
                      onChange={(e) => {
                        this.handleChange(e, "email");
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <div className="">
                    <input
                      id="password"
                      type="password"
                      onChange={(e) => {
                        this.handleChange(e, "password");
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <button
                    onClick={(e) => {
                      this.submitLogin(e);
                    }}
                    className="btn btn-primary"
                  >
                    Log In
                  </button>
                </div>
              </form>
              <NavLink to="/forgot_pw">Forgot password?</NavLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
